import { createSelector } from '@reduxjs/toolkit';
import groupBy from 'lodash/groupBy';

import { advancementHistoryItemsSel } from '@modules/advancement/pendingItems/duck/selectorsTyped';

import {
  advancementHistoryModuleName,
  advancementModuleName,
} from '../../constants';

const advancementModuleSel = state => state[advancementModuleName];

export const advancementHistoryModuleSel = state =>
  advancementModuleSel(state)[advancementHistoryModuleName];
export const advancementHistoryLoadingSel = state =>
  advancementHistoryModuleSel(state).loading;
export const advancementHistoryRawItemsSel = state =>
  advancementHistoryModuleSel(state).items;

export const pendingApprovableAdvancementsSel = createSelector(
  advancementHistoryItemsSel,
  items => {
    const filtered = items.filter(
      ({ isAdvancementPendingApprovable, isDeclined, isAdvancementPending }) =>
        isAdvancementPending && isAdvancementPendingApprovable && !isDeclined,
    );

    return filtered;
  },
);
export const pendingAdvancementsByTypeSel = createSelector(
  pendingApprovableAdvancementsSel,
  items => {
    const grouped = groupBy(items, item => {
      if (item.type === 'activity') return 'activities';
      return item.advancementType;
    });
    return grouped;
  },
);
export const historyItemsSel = createSelector(
  advancementHistoryItemsSel,
  items => items.filter(({ isAdvancementPending }) => !isAdvancementPending),
);

export const approvedAdvancementsSel = createSelector(
  advancementHistoryItemsSel,
  items =>
    items.filter(
      ({ status, type }) => status === 'approved' && type === 'advancement',
    ),
);
